'use client';
import React, { use, useEffect, useState } from 'react';
import Image from 'next/image';
import {
	useAuthenticated,
	useReady,
	UserVisibilityEnum,
	useUser,
	useUserVisibility,
} from '@/store';
import { useUpdateGeoLocation } from '@/backend/user/post-geo-location';
import ModalWrapper from '@/components/Modals/ModalWrapper/ModalWrapper';
import { useRouter } from 'next/navigation';
import { useGetInitialAppSettingsAndGeo } from '@/backend/settings/get-initial-app-settings-and-geo';
import GeoBlockModal from '@/app/(home)/components/GeoBlockModal/GeoBlockModal';
import MaintenancePage from '@/components/MaintenancePage/MaintenancePage';

const Loader_Page_Primary = () => {
	const router = useRouter();
	const ready = useReady();
	const authenticated = useAuthenticated();
	const user = useUser();
	const userVisibility = useUserVisibility();
	const [geoCalledForUser, setGeoCalledForUser] = useState(false);

	const { getInitialAppSettingsAndGeo } = useGetInitialAppSettingsAndGeo();
	/* -------------------------------------------------------------------------- */

	/* -------------------------------------------------------------------------- */
	useEffect(() => {
		if (ready && !user && !authenticated) {
			getInitialAppSettingsAndGeo();
		} else if (ready && user && !geoCalledForUser) {
			getInitialAppSettingsAndGeo();
		}
	}, [ready, user, authenticated]);
	// useEffect(() => {
	// 	if (!geoCalledForUser && user) {
	// 		getInitialAppSettingsAndGeo();
	// 		setGeoCalledForUser(true);
	// 	}
	// }, [user]);

	useEffect(() => {
		if (ready && !authenticated && userVisibility === UserVisibilityEnum.OK) {
			const glittersLeft = document.getElementById('glitters-left');
			const glittersRight = document.getElementById('glitters-right');

			if (glittersLeft) {
				glittersLeft.classList.add('opacityAnimationLeft');
			}
			if (glittersRight) {
				glittersRight.classList.add('opacityAnimationRight');
			}
		}
	}, [ready, authenticated, userVisibility]);

	if (ready && !authenticated && userVisibility === UserVisibilityEnum.OK) {
		return null;
	}

	if (
		ready &&
		authenticated &&
		user &&
		userVisibility === UserVisibilityEnum.OK
	) {
		return null;
	}

	if (userVisibility === UserVisibilityEnum.PENDING) {
		return (
			<div className=" grid place-content-center z-[10000] backdrop-blur-md top-0 fixed  left-0 h-screen w-screen overflow-x-hidden overflow-y-scroll bg-background-color ">
				<div className=" relative w-[300px] h-[300px]">
					<Image
						src="/Loading_Card_3.gif"
						alt="Loading..."
						priority
						fill
						className=" object-contain object-center"
					/>
				</div>
			</div>
		);
	}
	if (userVisibility === UserVisibilityEnum.MAINTENANCE) {
		return <MaintenancePage />;
	}
	if (userVisibility === UserVisibilityEnum.GEO_BLOCKED) {
		return <GeoBlockModal />;
	}
};

export default Loader_Page_Primary;

// export enum UserVisibilityEnum {
// 	GEO_BLOCKED = 'geo_blocked',
// 	MAINTENANCE = 'maintenance',
// 	OK = 'ok',
// 	PENDING = 'pending',
// }
